import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { Json } from '@/integrations/supabase/types';

export type LlmModel = {
  id: string;
  provider: string;
  display_name: string;
  description: string | null;
  is_active: boolean;
  is_recommended: boolean;
  recommendation_note: string | null;
  price_tier: string | null;
  context_window: number | null;
  sort_order: number;
  capabilities: Json;
  input_modalities: string[];
  created_at: string;
  updated_at: string;
};

export function useModels() {
  return useQuery<LlmModel[]>({
    queryKey: ['llm_models'],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('llm_models')
        .select('*')
        .eq('is_active', true)
        .order('sort_order', { ascending: true });
      if (error) throw error;
      return data ?? [];
    },
    staleTime: 60_000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
}
